import { Resources } from "web_myplann/Infrastructure/Translations/Resources";

const R = Resources.Advisor.deleteConfirm;

type Args = {
	isAssistant: boolean;
	hasSharedData: boolean;
};

export const getAdvisorDeleteConfirmCopy = ({
	isAssistant,
	hasSharedData,
}: Args) => ({
	title: isAssistant ? R.assistantTitle : R.advisorTitle,
	description: isAssistant
		? hasSharedData
			? R.assistantSharedDescription
			: R.assistantDescription
		: hasSharedData
			? R.advisorSharedDescription
			: R.advisorDescription,
	confirmLabel: isAssistant ? R.assistantConfirm : R.advisorConfirm,
});
